/**Dependencies */
import React from "react";
// import Slider from "react-slick";

/**Components */
import Button from "react-bootstrap/Button";

/**Images */

/**Styles */
import "../styles/transportation.scss";
import { Link } from "react-router-dom";
import { FaPhone } from "react-icons/fa6";

export const BannerDudas = ({
  imgDudasDesk,
  imgDudasMovil,
  bannerDudas = false,
}) => {
  return (
    <>
      <div className="position-relative">
        <img src={imgDudasDesk} className="w-100 d-sm-block d-none" alt="" />
        <img
          src={imgDudasMovil}
          className="w-100 d-sm-none rounded-5 d-block p-2"
          alt=""
        />
        {bannerDudas ? (
          <Link to={"tel:9982189740"}>
            <Button
              type="button"
              className="btn-blue btn-float-right  btn-aclara-dudas"
            >
              <FaPhone /> 998 218 9740
            </Button>
          </Link>
        ) : (
          <div>
            <Link to={"tel:9982189740"}>
              <Button
                type="button"
                className="btn-blue btn-float-right btn-aclara-dudas"
              >
                <FaPhone /> 998 218 9740
              </Button>
            </Link>
            {/* <Link to={"tel:9982189740"} className="d-sm-none d-block">
              <Button
                type="button"
                className="btn-blue btn-float-right p-3 btn-contact-time"
              >
                <MdAddCall /> Agenda una llamada
              </Button>
            </Link> */}
          </div>
        )}
      </div>
    </>
  );
};
